module.exports = __webpack_public_path__ + "static/natalie-c3792df7fe69f508b310ce484ca605ff.png";